var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNews(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(11429 3625)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-11427.667 -3622.333)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M296.124,520.836h-11.2a3.567,3.567,0,0,1-3.606-3.517v-8.3a3.566,3.566,0,0,1,3.606-3.517H290.7a3.566,3.566,0,0,1,3.606,3.517v8.3a.456.456,0,0,1-.911,0v-8.3a2.665,2.665,0,0,0-2.695-2.628H284.92a2.665,2.665,0,0,0-2.695,2.628v8.3a2.665,2.665,0,0,0,2.695,2.628h11.2a.445.445,0,1,1,0,.889Z",
    transform: "translate(-281.314 -505.503)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.076 11.271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M337.353,560.738a3.363,3.363,0,0,1-3.039-3.606.456.456,0,0,1,.911,0,2.465,2.465,0,0,0,2.128,2.695.456.456,0,1,1,0,.911Z",
    transform: "translate(-334.314 -556.676)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.532 11.271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M338.743,560.738a.456.456,0,0,1,0-.911,2.351,2.351,0,0,0,2.1-2.239H336.77a.456.456,0,1,1,0-.911h4.557a.456.456,0,0,1,.456.456A3.363,3.363,0,0,1,338.743,560.738Z",
    transform: "translate(-336.314 -556.676)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.051 2.279)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M293.96,516.414h-3.19a.456.456,0,0,1,0-.911h3.19a.456.456,0,1,1,0,.911Z",
    transform: "translate(-290.314 -515.503)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.051 4.438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M298.745,526.414H290.77a.456.456,0,0,1,0-.911h7.975a.456.456,0,1,1,0,.911Z",
    transform: "translate(-290.314 -525.503)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.051 6.656)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M298.745,536.414H290.77a.456.456,0,0,1,0-.911h7.975a.456.456,0,1,1,0,.911Z",
    transform: "translate(-290.314 -535.503)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.051 8.875)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M298.745,546.414H290.77a.456.456,0,0,1,0-.911h7.975a.456.456,0,1,1,0,.911Z",
    transform: "translate(-290.314 -545.503)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.051 11.094)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M298.745,556.414H290.77a.456.456,0,0,1,0-.911h7.975a.456.456,0,1,1,0,.911Z",
    transform: "translate(-290.314 -555.503)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNews);
export default __webpack_public_path__ + "static/media/News.6dc3f04f65fb497b563e1e4bf9600d0c.svg";
export { ForwardRef as ReactComponent };